var _defs, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _path3, _g7, _g8, _g9, _g10, _g11, _g12, _path4, _path5, _path6, _path7, _path8, _g13, _path9, _g14, _g15, _g16, _path10, _g17, _g18, _g19, _path11, _path12, _path13, _path14, _path15, _g20, _path16, _path17, _path18, _path19, _g21, _g22, _g23, _path20, _path21, _path22, _path23, _g24, _g25, _g26, _g27, _g28, _path24, _path25, _path26, _path27, _g29, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g30, _path36, _g31, _path37, _path38, _path39, _path40, _path41, _g32;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrositesPhase4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1336.03 717.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .microsites-disable-phase4{\n        fill: #edeef0 !important; \n      }\n      .microsites-disable-phase4:hover {\n        pointer-events: none;\n        fill: #edeef0 !important; \n      }\n\n      .microsites-disable-diamond-phase4{\n        fill: #FED62F !important;\n      }\n      .microsites-disable-diamond-phase4:hover {\n        pointer-events: none;\n        fill: #FED62F !important;  \n      }\n      .microsites-phase4-1 {\n        stroke-width: .05px;\n      }\n\n      .microsites-phase4-1, .microsites-phase4-2, .microsites-phase4-3 {\n        fill: #fcce14;\n      }\n\n      .microsites-phase4-1, .microsites-phase4-3, .microsites-phase4-4, .microsites-phase4-5, .microsites-phase4-6 {\n        stroke: #fcce14;\n      }\n\n      .microsites-phase4-2, .microsites-phase4-7, .microsites-phase4-8, .microsites-phase4-9, .microsites-phase4-10 {\n        stroke-width: 0px;\n      }\n\n      .microsites-phase4-11 {\n        fill: rgba(255, 255, 255, 0);\n      }\n      .microsites-phase4-11:hover {\n        fill: rgba(255, 255, 255, 0);\n      }\n\n      .microsites-phase4-11, .microsites-phase4-12 {\n        stroke: rgba(0, 0, 0, 0);\n      }\n\n      .microsites-phase4-8 {\n        fill: #333;\n      }\n\n      .microsites-phase4-12 {\n        ", "\n        fill: none;\n      }\n\n      .microsites-phase4-9, .microsites-phase4-5 {\n        fill: #fff;\n      }\n\n      .microsites-phase4-4 {\n        fill: url(#linear-gradient-microsites-phase4-2);\n      }\n\n      .microsites-phase4-4, .microsites-phase4-5 {\n        stroke-width: 2px;\n      }\n\n      .microsites-phase4-10 {\n        fill: #3a414a;\n      }\n\n      .microsites-phase4-6 {\n        fill: none;\n      }\n\n      .microsites-phase4-13 {\n        fill: url(#linear-gradient-microsites-phase4);\n        stroke: #1071e5;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-microsites-phase4",
    x1: 4091.21,
    y1: -846.95,
    x2: 4091.21,
    y2: -945.63,
    gradientTransform: "translate(-3364.97 -400.14) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#cfe4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-microsites-phase4-2",
    x1: 3596.83,
    y1: -666.74,
    x2: 3596.83,
    y2: -798.29,
    gradientTransform: "translate(-3364.97 -400.14) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe57f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fcce14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7ac03"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-12",
    d: "M.5,6.5C.5,3.19,3.19.5,6.5.5h1323.03c3.31,0,6,2.69,6,6v704.38c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6V6.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "rect-1",
    className: "microsites-phase4-5",
    d: "M55.26,122.88c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H61.26c-3.31,0-6-2.69-6-6v-86.67Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "T",
    className: "microsites-phase4-7",
    d: "M102.36,151.81c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U",
    className: "microsites-phase4-7",
    d: "M112,144.95c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM111.46,156.77c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V",
    className: "microsites-phase4-7",
    d: "M123.55,144.95c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM124.16,146.58c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W",
    className: "microsites-phase4-7",
    d: "M140.93,155.68c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM134.61,154.53c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X",
    className: "microsites-phase4-7",
    d: "M148.94,154.93c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y",
    className: "microsites-phase4-7",
    d: "M158.52,144.95c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM162.05,150.45c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Z",
    className: "microsites-phase4-7",
    d: "M186.49,145.97c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa",
    className: "microsites-phase4-7",
    d: "M191.72,158.13v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    className: "microsites-phase4-7",
    d: "M214.6,143.19v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ac",
    className: "microsites-phase4-7",
    d: "M233.95,144.95c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM233.89,156.77c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    className: "microsites-phase4-7",
    d: "M248.69,144.95c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "W-2",
    "data-name": "W",
    className: "microsites-phase4-7",
    d: "M270.69,155.68c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM264.37,154.53c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ae",
    className: "microsites-phase4-7",
    d: "M295.74,146.65c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-2",
    "data-name": "ac",
    className: "microsites-phase4-7",
    d: "M308.58,144.95c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM308.51,156.77c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-2",
    "data-name": "ad",
    className: "microsites-phase4-7",
    d: "M323.31,144.95c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-2",
    "data-name": "X",
    className: "microsites-phase4-7",
    d: "M332.95,154.93c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af",
    className: "microsites-phase4-7",
    d: "M342.94,146.65c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag",
    className: "microsites-phase4-7",
    d: "M350.95,158.13v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah",
    className: "microsites-phase4-7",
    d: "M366.84,145.22l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ai",
    className: "microsites-phase4-7",
    d: "M206.08,171.35c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM205.54,183.17c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-3",
    "data-name": "W",
    className: "microsites-phase4-7",
    d: "M221.43,182.08c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM215.11,180.93c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj",
    className: "microsites-phase4-7",
    d: "M234.6,174.82c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak",
    className: "microsites-phase4-7",
    d: "M239.28,168.84v-2.04h2.17v2.04h-2.17ZM239.28,184.53v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-2",
    "data-name": "aj",
    className: "microsites-phase4-7",
    d: "M252.19,174.82c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "rect-3",
    className: "microsites-phase4-5",
    d: "M555.53,125.28c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v86.66c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-86.66Z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "al",
    className: "microsites-phase4-10",
    d: "M633.5,140.7c5.5,0,8.35,3.12,8.35,8.56,0,4.89-2.38,7.94-6.79,8.56.48,2.04,2.04,3.26,4.69,2.72v1.56c-3.73,1.09-6.45-1.02-6.99-4.14-4.96-.41-7.6-3.46-7.6-8.69s2.85-8.56,8.35-8.56ZM633.5,156.11c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am",
    className: "microsites-phase4-10",
    d: "M648.71,158.01c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an",
    className: "microsites-phase4-10",
    d: "M666.16,155.29c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM659.84,154.14c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao",
    className: "microsites-phase4-10",
    d: "M677.9,146.67c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap",
    className: "microsites-phase4-10",
    d: "M682.25,154.55c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq",
    className: "microsites-phase4-10",
    d: "M691.82,144.57c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM695.35,150.07c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-2",
    "data-name": "ao",
    className: "microsites-phase4-10",
    d: "M706.35,146.67c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar",
    className: "microsites-phase4-10",
    d: "M708.32,157.74v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as",
    className: "microsites-phase4-10",
    d: "M724.21,144.84l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at",
    className: "microsites-phase4-10",
    d: "M732.7,142.05v-2.04h2.17v2.04h-2.17ZM732.7,157.74v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au",
    className: "microsites-phase4-10",
    d: "M744.38,144.57c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av",
    className: "microsites-phase4-10",
    d: "M757.35,157.74h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-2",
    "data-name": "aq",
    className: "microsites-phase4-10",
    d: "M769.03,144.57c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM772.56,150.07c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-2",
    "data-name": "au",
    className: "microsites-phase4-10",
    d: "M783.76,144.57c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-2",
    "data-name": "ap",
    className: "microsites-phase4-10",
    d: "M793.4,154.55c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw",
    className: "microsites-phase4-10",
    d: "M802.98,144.57c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM802.91,156.38c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-3",
    "data-name": "ao",
    className: "microsites-phase4-10",
    d: "M817.51,146.67c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-2",
    "data-name": "as",
    className: "microsites-phase4-10",
    d: "M830,144.84l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ao-4",
    "data-name": "ao",
    className: "microsites-phase4-10",
    d: "M612.04,176c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-3",
    "data-name": "aq",
    className: "microsites-phase4-10",
    d: "M619.17,173.9c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM622.7,179.4c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-2",
    "data-name": "av",
    className: "microsites-phase4-10",
    d: "M633.29,187.07h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-2",
    "data-name": "at",
    className: "microsites-phase4-10",
    d: "M639.81,171.39v-2.04h2.17v2.04h-2.17ZM639.81,187.07v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-4",
    "data-name": "aq",
    className: "microsites-phase4-10",
    d: "M650.34,173.9c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM653.87,179.4c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax",
    className: "microsites-phase4-10",
    d: "M671.11,187.07h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay",
    className: "microsites-phase4-10",
    d: "M683.88,177.36c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "az",
    className: "microsites-phase4-10",
    d: "M701.53,173.9c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM700.99,185.71c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-3",
    "data-name": "as",
    className: "microsites-phase4-10",
    d: "M719.46,174.17l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "az-2",
    "data-name": "az",
    className: "microsites-phase4-10",
    d: "M734.13,173.9c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM733.58,185.71c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-5",
    "data-name": "ao",
    className: "microsites-phase4-10",
    d: "M747.64,176c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-2",
    "data-name": "an",
    className: "microsites-phase4-10",
    d: "M757.55,184.63c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM751.24,183.47c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-3",
    "data-name": "au",
    className: "microsites-phase4-10",
    d: "M769.5,173.9c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA",
    className: "microsites-phase4-10",
    d: "M780.91,173.9c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM781.52,175.53c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ap-3",
    "data-name": "ap",
    className: "microsites-phase4-10",
    d: "M799.51,183.88c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-5",
    "data-name": "aq",
    className: "microsites-phase4-10",
    d: "M809.09,173.9c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM812.62,179.4c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-3",
    "data-name": "an",
    className: "microsites-phase4-10",
    d: "M825.45,184.63c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM819.14,183.47c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB",
    className: "microsites-phase4-10",
    d: "M843.72,175.6c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-1",
    d: "M1001.67,166.96l1,.24.94.4.87.52.77.66.67.78.52.87.4.94.23,1,.08,1v11.62h-1v-11.58l-.07-.88-.2-.84-.33-.8-.45-.73-.57-.66-.64-.57-.74-.45-.8-.33-.83-.2-.9-.08h-15.2v-1h15.25l1,.09ZM899.27,167.88v-1h17.04v1h-17.04Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-2",
    d: "M899.3,167.88h-.52v-1h.52v1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-1",
    d: "M899.33,167.91h-.57v-1.05h.56v1.05ZM898.81,166.91v.95h.46v-.95h-.46Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-2",
    d: "M1006.66,199.74l-4.64-14.26h9.26l-4.62,14.26Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-1",
    d: "M1006.66,201.36l-5.33-16.38h10.65l-5.32,16.38ZM1002.71,185.98l3.95,12.14,3.94-12.14h-7.89Z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aC",
    className: "microsites-phase4-8",
    d: "M932.61,160.46c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM921.48,163.17c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD",
    className: "microsites-phase4-8",
    d: "M946.47,169.01c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM943.41,164.33c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE",
    className: "microsites-phase4-8",
    d: "M955.29,172.07c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF",
    className: "microsites-phase4-8",
    d: "M957.26,157.06v-2.51h3.4v2.51h-3.4ZM957.26,172.27v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aG",
    className: "microsites-phase4-8",
    d: "M971.52,162.09c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-2",
    "data-name": "aD",
    className: "microsites-phase4-8",
    d: "M984.42,169.01c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM981.37,164.33c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "rect-5",
    className: "microsites-phase4-13",
    d: "M628.23,452.81c0-3.31,2.69-6,6-6h184.02c3.31,0,6,2.69,6,6v86.66c.01,3.31-2.67,6.01-5.98,6.02h-184.04c-3.31,0-6-2.69-6-6v-86.68Z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aH",
    className: "microsites-phase4-9",
    d: "M666.94,489.6c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI",
    className: "microsites-phase4-9",
    d: "M684.33,498.7c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM681.27,494.01c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-2",
    "data-name": "aI",
    className: "microsites-phase4-9",
    d: "M697.91,498.7c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM694.85,494.01c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aJ",
    className: "microsites-phase4-9",
    d: "M707.34,485.12c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84ZM710.88,493.33c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aK",
    className: "microsites-phase4-9",
    d: "M729.75,491.3c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL",
    className: "microsites-phase4-9",
    d: "M745.91,499.65c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM742.65,499.85c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM",
    className: "microsites-phase4-9",
    d: "M759.76,492.59c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-3",
    "data-name": "aI",
    className: "microsites-phase4-9",
    d: "M776.6,498.7c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM773.55,494.01c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aN",
    className: "microsites-phase4-9",
    d: "M796.77,489.6c0,5.3-5.7,5.84-7.54,9.57h7.81v2.78h-11.81c-.41-6.86,6.72-6.79,8.15-12.22.07-1.49-.81-2.1-2.24-2.17-1.56,0-2.17.95-2.38,2.31l-3.33-.2c.34-3.06,2.17-4.75,5.7-4.75s5.64,1.49,5.64,4.69"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "rect-4",
    className: "microsites-phase4-5",
    d: "M655.53,291.44c0-3.31,2.69-6,6-6h128c3.31,0,6,2.69,6,6v86.66c0,3.31-2.69,6-6,6h-128c-3.31,0-6-2.69-6-6v-86.66Z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aO",
    className: "microsites-phase4-10",
    d: "M688.35,317.58c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP",
    className: "microsites-phase4-10",
    d: "M698,310.73c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM697.45,322.54c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-2",
    "data-name": "aA",
    className: "microsites-phase4-10",
    d: "M709.54,310.73c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM710.15,312.36c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-4",
    "data-name": "an",
    className: "microsites-phase4-10",
    d: "M726.92,321.45c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM720.61,320.3c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-4",
    "data-name": "ap",
    className: "microsites-phase4-10",
    d: "M734.93,320.71c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-6",
    "data-name": "aq",
    className: "microsites-phase4-10",
    d: "M744.51,310.73c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM748.04,316.23c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw-2",
    "data-name": "aw",
    className: "microsites-phase4-10",
    d: "M764.88,310.73c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM764.81,322.54c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ",
    className: "microsites-phase4-10",
    d: "M778.53,308.01c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aB-2",
    "data-name": "aB",
    className: "microsites-phase4-10",
    d: "M696.47,341.76c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-5",
    "data-name": "an",
    className: "microsites-phase4-10",
    d: "M712.09,350.79c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM705.77,349.63c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-5",
    "data-name": "ap",
    className: "microsites-phase4-10",
    d: "M720.1,350.04c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-7",
    "data-name": "aq",
    className: "microsites-phase4-10",
    d: "M729.67,340.06c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM733.2,345.56c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-6",
    "data-name": "ao",
    className: "microsites-phase4-10",
    d: "M744.2,342.16c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-3",
    "data-name": "at",
    className: "microsites-phase4-10",
    d: "M746.17,337.55v-2.04h2.17v2.04h-2.17ZM746.17,353.23v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-6",
    "data-name": "an",
    className: "microsites-phase4-10",
    d: "M759.48,350.79c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM753.17,349.63c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-2",
    "data-name": "ar",
    className: "microsites-phase4-10",
    d: "M765.12,353.23v-17.72h2.17v17.72h-2.17"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-1",
    d: "M922.3,335.26h-125.27v-1h125.27v1ZM1007.16,328.79l-.08,1-.24,1-.38.93-.53.87-.68.78-.77.67-.87.53-.94.4-1,.23-1,.08h-9.24v-1h9.2l.9-.06.82-.2.8-.33.74-.44.65-.56.57-.66.46-.73.33-.8.2-.83.07-.88v-12.35h1v12.35Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-2",
    d: "M797.03,335.26h-.5v-1h.5v1Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-1",
    d: "M797.07,335.3h-.56v-1.05h.56v1.05ZM796.55,334.3v.95h.47v-.96h-.47Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-2",
    d: "M1011.29,315.91h-9.27l4.63-14.26,4.64,14.26Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-1",
    d: "M1011.98,316.41h-10.65l5.33-16.38,5.32,16.38ZM1002.71,315.41h7.9l-3.95-12.15-3.95,12.15Z"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "m-2",
    "data-name": "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aC-2",
    "data-name": "aC",
    className: "microsites-phase4-8",
    d: "M938.6,327.84c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM927.47,330.56c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-3",
    "data-name": "aD",
    className: "microsites-phase4-8",
    d: "M952.45,336.4c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM949.4,331.71c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-2",
    "data-name": "aE",
    className: "microsites-phase4-8",
    d: "M961.28,339.46c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF-2",
    "data-name": "aF",
    className: "microsites-phase4-8",
    d: "M963.25,324.45v-2.51h3.4v2.51h-3.4ZM963.25,339.66v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aG-2",
    "data-name": "aG",
    className: "microsites-phase4-8",
    d: "M977.51,329.47c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-4",
    "data-name": "aD",
    className: "microsites-phase4-8",
    d: "M990.41,336.4c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM987.36,331.71c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-6",
    d: "M725.53,385.6l.52,44.33"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-1",
    d: "M726.03,385.61h-1v-.5h1v.5Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-3",
    d: "M726.23,444.69l-4.8-14.2,9.26-.12-4.46,14.32Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "rect-6",
    className: "microsites-phase4-11",
    d: "M835.53,207.36c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-86.67Z"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aR",
    className: "microsites-phase4-10",
    d: "M947.24,244.15c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS",
    className: "microsites-phase4-10",
    d: "M964.63,253.25c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM961.57,248.56c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-2",
    "data-name": "aS",
    className: "microsites-phase4-10",
    d: "M978.21,253.25c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM975.15,248.56c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aT",
    className: "microsites-phase4-10",
    d: "M987.64,239.67c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84ZM991.17,247.89c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU",
    className: "microsites-phase4-10",
    d: "M1010.05,245.85c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV",
    className: "microsites-phase4-10",
    d: "M1026.21,254.2c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM1022.95,254.4c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW",
    className: "microsites-phase4-10",
    d: "M1040.06,247.14c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-3",
    "data-name": "aS",
    className: "microsites-phase4-10",
    d: "M1056.9,253.25c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM1053.85,248.56c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aX",
    className: "microsites-phase4-10",
    d: "M1074.15,251.01c0-3.12-3.73-3.73-4.96-1.83h-3.26l.61-9.51h10.12v2.51h-7.06l-.27,4.28c2.99-2.58,9.03-.27,8.28,4.48.75,6.99-11.48,7.94-12.15,1.36l3.33-.27c.34,1.22,1.02,2.04,2.65,2.04,1.77,0,2.72-1.22,2.72-3.06"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-6",
    d: "M726.31,219.44l-.33,48.6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-1",
    d: "M726.81,219.46h-1v-.52h1v.52Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-3",
    d: "M725.88,282.82l-4.54-14.3,9.28.06-4.74,14.24Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-disable-diamond-phase4",
    d: "M226.25,268.76c3.6-1.39,7.6-1.39,11.2,0l159.93,61.46c1.19.45,1.78,1.78,1.33,2.97-.23.61-.72,1.1-1.33,1.33l-159.93,61.48c-3.6,1.39-7.6,1.39-11.2,0l-159.92-61.47c-1.19-.45-1.78-1.78-1.33-2.97.23-.61.72-1.1,1.33-1.33l159.92-61.47Z"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aY",
    className: "microsites-phase4-9",
    d: "M176.49,301.2c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ",
    className: "microsites-phase4-9",
    d: "M181.86,298.34v-2.04h2.17v2.04h-2.17ZM181.86,314.03v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba",
    className: "microsites-phase4-9",
    d: "M189.6,310.84c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb",
    className: "microsites-phase4-9",
    d: "M199.17,300.86c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM202.7,306.36c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bc",
    className: "microsites-phase4-9",
    d: "M227.01,302.55c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-2",
    "data-name": "bb",
    className: "microsites-phase4-9",
    d: "M239.84,300.86c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM243.37,306.36c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-3",
    "data-name": "bb",
    className: "microsites-phase4-9",
    d: "M253.42,300.86c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM256.95,306.36c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-2",
    "data-name": "ba",
    className: "microsites-phase4-9",
    d: "M264.22,310.84c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-2",
    "data-name": "aZ",
    className: "microsites-phase4-9",
    d: "M268.63,298.34v-2.04h2.17v2.04h-2.17ZM268.63,314.03v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd",
    className: "microsites-phase4-9",
    d: "M280.31,300.86c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be",
    className: "microsites-phase4-9",
    d: "M297.97,301.13c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM292.33,312.53c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ba-3",
    "data-name": "ba",
    className: "microsites-phase4-9",
    d: "M132.59,337.24c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf",
    className: "microsites-phase4-9",
    d: "M142.17,327.26c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM142.1,339.07c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg",
    className: "microsites-phase4-9",
    d: "M154.66,340.7c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh",
    className: "microsites-phase4-9",
    d: "M169.06,328.95c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi",
    className: "microsites-phase4-9",
    d: "M181.96,328.95c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj",
    className: "microsites-phase4-9",
    d: "M196.15,327.26c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM195.61,339.07c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf-2",
    "data-name": "bf",
    className: "microsites-phase4-9",
    d: "M208.71,327.26c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM208.64,339.07c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-3",
    "data-name": "aZ",
    className: "microsites-phase4-9",
    d: "M217.13,324.74v-2.04h2.17v2.04h-2.17ZM217.13,340.43v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd-2",
    "data-name": "bd",
    className: "microsites-phase4-9",
    d: "M228.81,327.26c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-4",
    "data-name": "ba",
    className: "microsites-phase4-9",
    d: "M238.45,337.24c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bk",
    className: "microsites-phase4-9",
    d: "M254.88,324.54c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf-3",
    "data-name": "bf",
    className: "microsites-phase4-9",
    d: "M261.61,327.26c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM261.54,339.07c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl",
    className: "microsites-phase4-9",
    d: "M276.14,329.36c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-4",
    "data-name": "bb",
    className: "microsites-phase4-9",
    d: "M283.27,327.26c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM286.8,332.76c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh-2",
    "data-name": "bh",
    className: "microsites-phase4-9",
    d: "M296.58,328.95c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bm",
    className: "microsites-phase4-9",
    d: "M311.85,337.98c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM305.54,336.83c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bn",
    className: "microsites-phase4-9",
    d: "M325.03,330.72c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-5",
    "data-name": "ba",
    className: "microsites-phase4-9",
    d: "M332.09,337.24c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bc-2",
    "data-name": "bc",
    className: "microsites-phase4-9",
    d: "M218.86,355.35c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-5",
    "data-name": "bb",
    className: "microsites-phase4-9",
    d: "M231.7,353.66c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM235.23,359.16c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-6",
    "data-name": "ba",
    className: "microsites-phase4-9",
    d: "M242.49,363.64c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo",
    className: "microsites-phase4-9",
    d: "M252.27,349.79c5.7,0,7.54,6.59,3.06,9.03-1.29.68-2.51,1.63-2.65,3.53h-2.1c0-4.28,5.23-3.73,5.23-7.74,0-2.04-1.43-2.85-3.53-2.92-2.17,0-3.6,1.15-3.8,3.12l-2.17-.14c.48-3.06,2.31-4.89,5.98-4.89ZM250.5,366.83v-2.38h2.31v2.38h-2.31"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-6",
    d: "M231.85,217.06v33.27"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-1",
    d: "M232.35,217.06h-1v-.5h1v.5Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-3",
    d: "M231.85,265.09l-4.64-14.26h9.28l-4.64,14.26Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "rect-2",
    className: "microsites-phase4-5",
    d: "M242.48,527.36c0-3.31,2.69-6,6-6h143.03c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-143.03c-3.31,0-6-2.69-6-6v-86.67Z"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bp",
    className: "microsites-phase4-10",
    d: "M282.73,533.08c-.25-2.37-6.07-2.67-6.12.1.69,3.7,7.8.69,8.05,5.88.15,3.85-5.98,4.3-8.64,2.72-.84-.49-1.38-1.28-1.63-2.27l1.63-.35c.25,2.77,6.96,3.11,6.96-.05,0-3.85-7.65-.69-8-5.83-.25-4.05,7.16-4.15,8.84-1.68.25.35.4.79.54,1.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq",
    className: "microsites-phase4-10",
    d: "M292.36,530.02c4,0,6.07,2.27,6.07,6.22s-2.17,6.37-6.07,6.37-6.07-2.42-6.07-6.37,2.07-6.22,6.07-6.22ZM292.36,541.23c3.11,0,4.4-2.02,4.4-4.99s-1.43-4.89-4.4-4.89-4.4,1.93-4.4,4.89,1.38,4.94,4.4,4.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "br",
    className: "microsites-phase4-10",
    d: "M309.39,542.42l-1.38-3.56h-5.58l-1.38,3.56h-1.73l4.99-12.25h1.88l4.89,12.25h-1.68ZM307.52,537.53l-2.32-6.07c-.59,2.22-1.53,4.05-2.27,6.07h4.59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ay-2",
    "data-name": "ay",
    className: "microsites-phase4-10",
    d: "M321.74,535.35c-.15-1.68-4.25-1.88-4.3,0,.74,2.62,5.68.59,5.88,4.44s-7.41,3.65-7.75.4l1.38-.25c.2,1.78,4.79,2.22,4.84,0-.49-2.77-5.58-.74-5.83-4.44-.2-2.81,4.05-3.11,6.02-2.07.59.35,1.04.94,1.19,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs",
    className: "microsites-phase4-10",
    d: "M329.2,534.07c-3.56,0-2.17,5.04-2.42,8.35h-1.58v-12.89h1.58l-.05,5.09c.59-1.04,1.38-1.78,3.01-1.78,4.4,0,2.62,5.73,2.96,9.58h-1.58v-5.98c.1-1.58-.4-2.42-1.93-2.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-3",
    "data-name": "aw",
    className: "microsites-phase4-10",
    d: "M338.78,532.84c3.06-.05,4.2,1.83,4.2,4.89.05,3.11-1.33,4.89-4.25,4.89s-4.1-1.93-4.15-4.89c0-3.26,1.38-4.89,4.2-4.89ZM338.73,541.43c2.17.05,2.62-1.53,2.62-3.7s-.4-3.7-2.52-3.7-2.62,1.58-2.62,3.7.49,3.65,2.52,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-2",
    "data-name": "am",
    className: "microsites-phase4-10",
    d: "M347.86,542.61c-4.4.2-2.67-5.73-3.01-9.58h1.58v5.93c0,1.53.35,2.47,1.93,2.42,3.56-.1,2.22-4.99,2.47-8.35h1.53l.05,9.38h-1.48c-.05-.49.05-1.23-.1-1.63-.54,1.09-1.38,1.78-2.96,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-3",
    "data-name": "ar",
    className: "microsites-phase4-10",
    d: "M354.78,542.42v-12.89h1.58v12.89h-1.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-3",
    "data-name": "aA",
    className: "microsites-phase4-10",
    d: "M361.69,532.84c1.53,0,2.37.64,2.96,1.63l-.05-4.94h1.58l.05,12.89h-1.48c-.1-.49,0-1.14-.15-1.53-.49,1.14-1.38,1.73-2.91,1.73-2.62,0-3.41-1.93-3.46-4.84,0-3.26,1.14-4.94,3.46-4.94ZM362.13,534.02c-1.98,0-2.27,1.68-2.27,3.7s.3,3.65,2.22,3.65c2.07,0,2.52-1.58,2.52-3.75s-.44-3.65-2.47-3.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "an-7",
    "data-name": "an",
    className: "microsites-phase4-10",
    d: "M256.87,561.97c-.74,1.04-1.53,2.02-3.36,1.98-1.78-.05-2.86-1.04-2.86-2.81-.05-3.16,3.11-3.11,6.17-3.11.15-1.73-.44-2.67-2.02-2.67-1.19.05-2.02.35-2.07,1.53l-1.63-.15c.25-1.83,1.63-2.57,3.75-2.57s3.56.99,3.56,3.16v4.05c-.05.99.35,1.58,1.38,1.33v.99c-1.53.44-3.01-.1-2.91-1.73ZM252.28,561.13c0,.99.59,1.63,1.58,1.63,2.02-.15,3.11-1.43,2.96-3.65-2.12.1-4.54-.25-4.54,2.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt",
    className: "microsites-phase4-10",
    d: "M264.53,555.4c-1.98,0-2.37,1.63-2.37,3.6s.44,3.7,2.37,3.7c1.19,0,2.02-.69,2.12-1.88l1.58.1c-.3,1.83-1.53,3.01-3.65,3.01-2.91,0-3.75-2.02-4.05-4.89-.49-4.59,4.99-6.47,7.26-3.16.2.35.25.69.35,1.09l-1.58.15c-.2-1.04-.79-1.73-2.02-1.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-6",
    "data-name": "ap",
    className: "microsites-phase4-10",
    d: "M271.59,561.43c-.1,1.19.89,1.43,1.88,1.09v1.19c-1.63.49-3.46.25-3.46-1.93v-6.27h-1.09v-1.14h1.19l.44-2.12h1.04v2.12h1.73v1.14h-1.73v5.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-4",
    "data-name": "at",
    className: "microsites-phase4-10",
    d: "M274.8,552.34v-1.48h1.58v1.48h-1.58ZM274.8,563.75v-9.38h1.58v9.38h-1.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-4",
    "data-name": "aw",
    className: "microsites-phase4-10",
    d: "M282.46,554.17c3.06-.05,4.2,1.83,4.2,4.89.05,3.11-1.33,4.89-4.25,4.89s-4.1-1.93-4.15-4.89c0-3.26,1.38-4.89,4.2-4.89ZM282.41,562.76c2.17.05,2.62-1.53,2.62-3.7s-.4-3.7-2.52-3.7-2.62,1.58-2.62,3.7.49,3.65,2.52,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-4",
    "data-name": "au",
    className: "microsites-phase4-10",
    d: "M293.17,554.17c4.4-.2,2.62,5.73,2.96,9.58h-1.58v-5.98c0-1.53-.4-2.42-1.93-2.37-3.56.1-2.17,5.04-2.42,8.35h-1.58l-.05-9.38h1.48c.05.49-.05,1.19.1,1.58.54-1.09,1.43-1.73,3.01-1.78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ap-7",
    "data-name": "ap",
    className: "microsites-phase4-10",
    d: "M305.12,561.43c-.1,1.19.89,1.43,1.88,1.09v1.19c-1.63.49-3.46.25-3.46-1.93v-6.27h-1.09v-1.14h1.19l.44-2.12h1.04v2.12h1.73v1.14h-1.73v5.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-5",
    "data-name": "aw",
    className: "microsites-phase4-10",
    d: "M312.08,554.17c3.06-.05,4.2,1.83,4.2,4.89.05,3.11-1.33,4.89-4.25,4.89s-4.1-1.93-4.15-4.89c0-3.26,1.38-4.89,4.2-4.89ZM312.04,562.76c2.17.05,2.62-1.53,2.62-3.7s-.4-3.7-2.52-3.7-2.62,1.58-2.62,3.7.49,3.65,2.52,3.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aB-3",
    "data-name": "aB",
    className: "microsites-phase4-10",
    d: "M332.33,555.4c-3.31.15-1.88,5.19-2.17,8.35h-1.53v-5.98c0-1.43-.25-2.47-1.73-2.37-3.26.2-1.88,5.14-2.17,8.35h-1.53l-.05-9.38h1.48c.05.49-.05,1.19.1,1.58.49-2.17,4.89-2.47,5.28,0,.54-1.04,1.33-1.73,2.86-1.78,4.2-.1,2.32,5.88,2.72,9.58h-1.53v-5.98c0-1.43-.25-2.42-1.73-2.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-8",
    "data-name": "aq",
    className: "microsites-phase4-10",
    d: "M341.66,554.17c3.11,0,4.25,2.07,4.15,5.23h-6.67c0,1.98.69,3.31,2.62,3.36,1.28.05,2.12-.59,2.42-1.43l1.38.4c-.54,1.38-1.83,2.22-3.8,2.22-2.86,0-4.35-1.83-4.3-4.94.05-3.01,1.28-4.84,4.2-4.84ZM344.23,558.17c.3-2.96-3.75-3.8-4.79-1.38-.15.35-.3.84-.3,1.38h5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-9",
    "data-name": "aq",
    className: "microsites-phase4-10",
    d: "M351.54,554.17c3.11,0,4.25,2.07,4.15,5.23h-6.67c0,1.98.69,3.31,2.62,3.36,1.28.05,2.12-.59,2.42-1.43l1.38.4c-.54,1.38-1.83,2.22-3.8,2.22-2.86,0-4.35-1.83-4.3-4.94.05-3.01,1.28-4.84,4.2-4.84ZM354.11,558.17c.3-2.96-3.75-3.8-4.79-1.38-.15.35-.3.84-.3,1.38h5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-8",
    "data-name": "ap",
    className: "microsites-phase4-10",
    d: "M359.39,561.43c-.1,1.19.89,1.43,1.88,1.09v1.19c-1.63.49-3.46.25-3.46-1.93v-6.27h-1.09v-1.14h1.19l.44-2.12h1.04v2.12h1.73v1.14h-1.73v5.93"
  })), /*#__PURE__*/React.createElement("g", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ap-9",
    "data-name": "ap",
    className: "microsites-phase4-10",
    d: "M369.27,561.43c-.1,1.19.89,1.43,1.88,1.09v1.19c-1.63.49-3.46.25-3.46-1.93v-6.27h-1.09v-1.14h1.19l.44-2.12h1.04v2.12h1.73v1.14h-1.73v5.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs-2",
    "data-name": "bs",
    className: "microsites-phase4-10",
    d: "M376.53,555.4c-3.56,0-2.17,5.04-2.42,8.35h-1.58v-12.89h1.58l-.05,5.09c.59-1.04,1.38-1.78,3.01-1.78,4.4,0,2.62,5.73,2.96,9.58h-1.58v-5.98c.1-1.58-.4-2.42-1.93-2.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-10",
    "data-name": "aq",
    className: "microsites-phase4-10",
    d: "M386.11,554.17c3.11,0,4.25,2.07,4.15,5.23h-6.67c0,1.98.69,3.31,2.62,3.36,1.28.05,2.12-.59,2.42-1.43l1.38.4c-.54,1.38-1.83,2.22-3.8,2.22-2.86,0-4.35-1.83-4.3-4.94.05-3.01,1.28-4.84,4.2-4.84ZM388.68,558.17c.3-2.96-3.75-3.8-4.79-1.38-.15.35-.3.84-.3,1.38h5.09"
  })), /*#__PURE__*/React.createElement("g", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aP-2",
    "data-name": "aP",
    className: "microsites-phase4-10",
    d: "M289.69,575.5c2.72.05,3.46,2.02,3.46,4.84s-.79,4.84-3.46,4.94c-1.53,0-2.42-.64-2.96-1.68l.05,5.19h-1.58l-.05-13.09h1.53l.1,1.48c.49-1.04,1.38-1.68,2.91-1.68ZM289.29,584.09c1.98,0,2.22-1.68,2.22-3.7s-.3-3.6-2.22-3.65c-2.07,0-2.52,1.58-2.52,3.75s.49,3.6,2.52,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-7",
    "data-name": "ao",
    className: "microsites-phase4-10",
    d: "M299.52,577.03c-3.85-.79-2.62,4.49-2.81,8.05h-1.58l-.05-9.38h1.48c.05.59-.05,1.43.1,1.93.3-1.33,1.14-2.42,2.86-2.02v1.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-6",
    "data-name": "aw",
    className: "microsites-phase4-10",
    d: "M304.7,575.5c3.06-.05,4.2,1.83,4.2,4.89.05,3.11-1.33,4.89-4.25,4.89s-4.1-1.93-4.15-4.89c0-3.26,1.38-4.89,4.2-4.89ZM304.65,584.09c2.17.05,2.62-1.53,2.62-3.7s-.4-3.7-2.52-3.7-2.62,1.58-2.62,3.7.49,3.65,2.52,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-4",
    "data-name": "aB",
    className: "microsites-phase4-10",
    d: "M320.01,576.74c-3.31.15-1.88,5.19-2.17,8.35h-1.53v-5.98c0-1.43-.25-2.47-1.73-2.37-3.26.2-1.88,5.14-2.17,8.35h-1.53l-.05-9.38h1.48c.05.49-.05,1.19.1,1.58.49-2.17,4.89-2.47,5.28,0,.54-1.04,1.33-1.73,2.86-1.78,4.2-.1,2.32,5.88,2.72,9.58h-1.53v-5.98c0-1.43-.25-2.42-1.73-2.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-5",
    "data-name": "at",
    className: "microsites-phase4-10",
    d: "M325.59,573.67v-1.48h1.58v1.48h-1.58ZM325.59,585.08v-9.38h1.58v9.38h-1.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-3",
    "data-name": "ay",
    className: "microsites-phase4-10",
    d: "M334.97,578.02c-.15-1.68-4.25-1.88-4.3,0,.74,2.62,5.68.59,5.88,4.44s-7.41,3.65-7.75.4l1.38-.25c.2,1.78,4.79,2.22,4.84,0-.49-2.77-5.58-.74-5.83-4.44-.2-2.81,4.05-3.11,6.02-2.07.59.35,1.04.94,1.19,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-11",
    "data-name": "aq",
    className: "microsites-phase4-10",
    d: "M342.13,575.5c3.11,0,4.25,2.07,4.15,5.23h-6.67c0,1.98.69,3.31,2.62,3.36,1.28.05,2.12-.59,2.42-1.43l1.38.4c-.54,1.38-1.83,2.22-3.8,2.22-2.86,0-4.35-1.83-4.3-4.94.05-3.01,1.28-4.84,4.2-4.84ZM344.7,579.5c.3-2.96-3.75-3.8-4.79-1.38-.15.35-.3.84-.3,1.38h5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-4",
    "data-name": "aA",
    className: "microsites-phase4-10",
    d: "M351.27,575.5c1.53,0,2.37.64,2.96,1.63l-.05-4.94h1.58l.05,12.89h-1.48c-.1-.49,0-1.14-.15-1.53-.49,1.14-1.38,1.73-2.91,1.73-2.62,0-3.41-1.93-3.46-4.84,0-3.26,1.14-4.94,3.46-4.94ZM351.71,576.69c-1.98,0-2.27,1.68-2.27,3.7s.3,3.65,2.22,3.65c2.07,0,2.52-1.58,2.52-3.75s-.44-3.65-2.47-3.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ap-10",
    "data-name": "ap",
    className: "microsites-phase4-10",
    d: "M246.95,604.09c-.1,1.19.89,1.43,1.88,1.09v1.19c-1.63.49-3.46.25-3.46-1.93v-6.27h-1.09v-1.14h1.19l.44-2.12h1.04v2.12h1.73v1.14h-1.73v5.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-7",
    "data-name": "aw",
    className: "microsites-phase4-10",
    d: "M253.91,596.84c3.06-.05,4.2,1.83,4.2,4.89.05,3.11-1.33,4.89-4.25,4.89s-4.1-1.93-4.15-4.89c0-3.26,1.38-4.89,4.2-4.89ZM253.86,605.43c2.17.05,2.62-1.53,2.62-3.7s-.4-3.7-2.52-3.7-2.62,1.58-2.62,3.7.49,3.65,2.52,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-3",
    "data-name": "am",
    className: "microsites-phase4-10",
    d: "M263,606.61c-4.4.2-2.67-5.73-3.01-9.58h1.58v5.93c0,1.53.35,2.47,1.93,2.42,3.56-.1,2.22-4.99,2.47-8.35h1.53l.05,9.38h-1.48c-.05-.49.05-1.23-.1-1.63-.54,1.09-1.38,1.78-2.96,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-2",
    "data-name": "bt",
    className: "microsites-phase4-10",
    d: "M273.47,598.07c-1.98,0-2.37,1.63-2.37,3.6s.44,3.7,2.37,3.7c1.19,0,2.02-.69,2.12-1.88l1.58.1c-.3,1.83-1.53,3.01-3.65,3.01-2.91,0-3.75-2.02-4.05-4.89-.49-4.59,4.99-6.47,7.26-3.16.2.35.25.69.35,1.09l-1.58.15c-.2-1.04-.79-1.73-2.02-1.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs-3",
    "data-name": "bs",
    className: "microsites-phase4-10",
    d: "M282.85,598.07c-3.56,0-2.17,5.04-2.42,8.35h-1.58v-12.89h1.58l-.05,5.09c.59-1.04,1.38-1.78,3.01-1.78,4.4,0,2.62,5.73,2.96,9.58h-1.58v-5.98c.1-1.58-.4-2.42-1.93-2.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-3",
    "data-name": "aP",
    className: "microsites-phase4-10",
    d: "M293.17,596.84c2.72.05,3.46,2.02,3.46,4.84s-.79,4.84-3.46,4.94c-1.53,0-2.42-.64-2.96-1.68l.05,5.19h-1.58l-.05-13.09h1.53l.1,1.48c.49-1.04,1.38-1.68,2.91-1.68ZM292.78,605.43c1.98,0,2.22-1.68,2.22-3.7s-.3-3.6-2.22-3.65c-2.07,0-2.52,1.58-2.52,3.75s.49,3.6,2.52,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-8",
    "data-name": "aw",
    className: "microsites-phase4-10",
    d: "M302.31,596.84c3.06-.05,4.2,1.83,4.2,4.89.05,3.11-1.33,4.89-4.25,4.89s-4.1-1.93-4.15-4.89c0-3.26,1.38-4.89,4.2-4.89ZM302.26,605.43c2.17.05,2.62-1.53,2.62-3.7s-.4-3.7-2.52-3.7-2.62,1.58-2.62,3.7.49,3.65,2.52,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-6",
    "data-name": "at",
    className: "microsites-phase4-10",
    d: "M308.43,595.01v-1.48h1.58v1.48h-1.58ZM308.43,606.42v-9.38h1.58v9.38h-1.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-5",
    "data-name": "au",
    className: "microsites-phase4-10",
    d: "M316.92,596.84c4.4-.2,2.62,5.73,2.96,9.58h-1.58v-5.98c0-1.53-.4-2.42-1.93-2.37-3.56.1-2.17,5.04-2.42,8.35h-1.58l-.05-9.38h1.48c.05.49-.05,1.19.1,1.58.54-1.09,1.43-1.73,3.01-1.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-11",
    "data-name": "ap",
    className: "microsites-phase4-10",
    d: "M323.94,604.09c-.1,1.19.89,1.43,1.88,1.09v1.19c-1.63.49-3.46.25-3.46-1.93v-6.27h-1.09v-1.14h1.19l.44-2.12h1.04v2.12h1.73v1.14h-1.73v5.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-4",
    "data-name": "ay",
    className: "microsites-phase4-10",
    d: "M332.63,599.35c-.15-1.68-4.25-1.88-4.3,0,.74,2.62,5.68.59,5.88,4.44s-7.41,3.65-7.75.4l1.38-.25c.2,1.78,4.79,2.22,4.84,0-.49-2.77-5.58-.74-5.83-4.44-.2-2.81,4.05-3.11,6.02-2.07.59.35,1.04.94,1.19,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu",
    className: "microsites-phase4-10",
    d: "M334.85,606.61l3.56-13.09h1.38l-3.56,13.09h-1.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-5",
    "data-name": "aB",
    className: "microsites-phase4-10",
    d: "M350.16,598.07c-3.31.15-1.88,5.19-2.17,8.35h-1.53v-5.98c0-1.43-.25-2.47-1.73-2.37-3.26.2-1.88,5.14-2.17,8.35h-1.53l-.05-9.38h1.48c.05.49-.05,1.19.1,1.58.49-2.17,4.89-2.47,5.28,0,.54-1.04,1.33-1.73,2.86-1.78,4.2-.1,2.32,5.88,2.72,9.58h-1.53v-5.98c0-1.43-.25-2.42-1.73-2.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-12",
    "data-name": "aq",
    className: "microsites-phase4-10",
    d: "M359.49,596.84c3.11,0,4.25,2.07,4.15,5.23h-6.67c0,1.98.69,3.31,2.62,3.36,1.28.05,2.12-.59,2.42-1.43l1.38.4c-.54,1.38-1.83,2.22-3.8,2.22-2.86,0-4.35-1.83-4.3-4.94.05-3.01,1.28-4.84,4.2-4.84ZM362.06,600.84c.3-2.96-3.75-3.8-4.79-1.38-.15.35-.3.84-.3,1.38h5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-12",
    "data-name": "ap",
    className: "microsites-phase4-10",
    d: "M367.34,604.09c-.1,1.19.89,1.43,1.88,1.09v1.19c-1.63.49-3.46.25-3.46-1.93v-6.27h-1.09v-1.14h1.19l.44-2.12h1.04v2.12h1.73v1.14h-1.73v5.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-8",
    "data-name": "ao",
    className: "microsites-phase4-10",
    d: "M375,598.37c-3.85-.79-2.62,4.49-2.81,8.05h-1.58l-.05-9.38h1.48c.05.59-.05,1.43.1,1.93.3-1.33,1.14-2.42,2.86-2.02v1.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-7",
    "data-name": "at",
    className: "microsites-phase4-10",
    d: "M376.43,595.01v-1.48h1.58v1.48h-1.58ZM376.43,606.42v-9.38h1.58v9.38h-1.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-3",
    "data-name": "bt",
    className: "microsites-phase4-10",
    d: "M383.89,598.07c-1.98,0-2.37,1.63-2.37,3.6s.44,3.7,2.37,3.7c1.19,0,2.02-.69,2.12-1.88l1.58.1c-.3,1.83-1.53,3.01-3.65,3.01-2.91,0-3.75-2.02-4.05-4.89-.49-4.59,4.99-6.47,7.26-3.16.2.35.25.69.35,1.09l-1.58.15c-.2-1.04-.79-1.73-2.02-1.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-5",
    "data-name": "ay",
    className: "microsites-phase4-10",
    d: "M394.7,599.35c-.15-1.68-4.25-1.88-4.3,0,.74,2.62,5.68.59,5.88,4.44s-7.41,3.65-7.75.4l1.38-.25c.2,1.78,4.79,2.22,4.84,0-.49-2.77-5.58-.74-5.83-4.44-.2-2.81,4.05-3.11,6.02-2.07.59.35,1.04.94,1.19,1.73"
  })))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-6",
    d: "M399.01,570.69h33.5c3.31,0,6-2.69,6-6V172.22c0-3.31-2.69-6-6-6h-17.62"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-1",
    d: "M399.03,571.19h-.52v-1h.5l.02,1Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-3",
    d: "M400.13,166.22l14.26-4.64v9.27l-14.26-4.63Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-1",
    d: "M320.49,503.98h-1v-13.3h1v13.3ZM232.35,453.18l.07.88.2.84.32.8.45.73.56.66.66.56.72.44.8.33.84.2.88.07h76.14l1,.08,1,.24.94.4.87.52.76.66.66.78.54.87.4.93.23,1,.06,1v4.17h-1v-4.14l-.07-.88-.2-.84-.34-.8-.45-.73-.55-.65-.65-.56-.74-.46-.8-.33-.84-.2-.88-.06h-76.14l-1-.08-1-.24-.93-.4-.87-.52-.78-.66-.66-.78-.53-.87-.4-.95-.23-1-.08-1v-54.67h1l.04,54.66Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-2",
    d: "M231.85,398.04l.5-.02v.53h-1v-.54l.5.03Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-1",
    d: "M231.85,398.02l.53-.02v.58h-1.05v-.58l.52.02ZM231.38,398.52h.95v-.47h-.95v.47Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-2",
    d: "M319.99,518.74l-4.63-14.26h9.27l-4.64,14.26Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-1",
    d: "M319.99,520.36l-5.32-16.38h10.65l-5.33,16.38ZM316.05,504.98l3.94,12.14,3.95-12.14h-7.89Z"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bv",
    className: "microsites-phase4-8",
    d: "M315.33,483.58l-5.33-9.43c.3,2.86.1,6.32.15,9.43h-2.27v-12.25h2.91l5.43,9.53c-.3-2.86-.1-6.37-.15-9.53h2.27v12.25h-3.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bw",
    className: "microsites-phase4-8",
    d: "M326.39,471.19c3.95,0,6.17,2.22,6.17,6.22s-2.27,6.37-6.22,6.37-6.12-2.37-6.12-6.37,2.17-6.22,6.17-6.22ZM326.34,481.75c2.57,0,3.6-1.73,3.6-4.35,0-2.47-1.04-4.25-3.56-4.25s-3.6,1.73-3.6,4.25,1.09,4.35,3.56,4.35"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-disable-phase4",
    d: "M55.26,527.36c0-3.31,2.69-6,6-6h143.03c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H61.26c-3.31,0-6-2.69-6-6v-86.67Z"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bx",
    className: "microsites-phase4-10",
    d: "M95.82,538.65c-.62-1.73-2.16-2.78-4.51-2.78-3.64,0-5.37,2.47-5.37,6.11s1.79,6.23,5.49,6.23c2.65,0,3.83-1.48,4.81-3.21l1.67.86c-1.11,2.35-3.15,4.07-6.6,4.07-4.94,0-7.22-3.09-7.47-7.96-.37-6.42,6.11-9.44,11.54-6.85,1.17.56,1.91,1.6,2.41,2.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-8",
    "data-name": "an",
    className: "microsites-phase4-10",
    d: "M107.42,547.48c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM101.68,546.43c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-6",
    "data-name": "aB",
    className: "microsites-phase4-10",
    d: "M124.03,539.27c-4.14.19-2.35,6.48-2.72,10.43h-1.91v-7.47c0-1.79-.31-3.09-2.16-2.96-4.07.25-2.35,6.42-2.72,10.43h-1.91l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.62-2.72,6.11-3.09,6.6,0,.68-1.3,1.67-2.16,3.58-2.22,5.25-.12,2.9,7.35,3.4,11.98h-1.91v-7.47c0-1.79-.31-3.02-2.16-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-4",
    "data-name": "aP",
    className: "microsites-phase4-10",
    d: "M136.62,537.73c3.4.06,4.32,2.53,4.32,6.05s-.99,6.05-4.32,6.17c-1.91,0-3.02-.8-3.7-2.1l.06,6.48h-1.98l-.06-16.36h1.91l.12,1.85c.62-1.3,1.73-2.1,3.64-2.1ZM136.13,548.47c2.47,0,2.78-2.1,2.78-4.63s-.37-4.51-2.78-4.57c-2.59,0-3.15,1.98-3.15,4.69s.62,4.51,3.15,4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-9",
    "data-name": "an",
    className: "microsites-phase4-10",
    d: "M150.57,547.48c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM144.83,546.43c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-8",
    "data-name": "at",
    className: "microsites-phase4-10",
    d: "M155.69,535.44v-1.85h1.98v1.85h-1.98ZM155.69,549.7v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "by",
    className: "microsites-phase4-10",
    d: "M170.02,537.97c-.62,7.72,2.53,18.09-6.79,16.11-1.42-.37-2.35-1.23-2.72-2.65l1.98-.31c.93,2.9,6.17,1.98,5.49-1.73v-1.85c-.68,1.3-1.79,2.22-3.77,2.22-3.33,0-4.2-2.53-4.2-5.93s.99-5.99,4.38-6.05c1.79-.06,2.96.99,3.64,2.16.06-.62,0-1.42.12-1.98h1.85ZM164.89,548.34c2.22,0,3.09-1.98,3.09-4.51s-.86-4.63-3.09-4.63c-2.41,0-2.84,2.1-2.84,4.63s.37,4.51,2.84,4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-6",
    "data-name": "au",
    className: "microsites-phase4-10",
    d: "M178.66,537.73c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ao-9",
    "data-name": "ao",
    className: "microsites-phase4-10",
    d: "M76.81,566.31c-4.81-.99-3.27,5.62-3.52,10.06h-1.98l-.06-11.73h1.85c.06.74-.06,1.79.12,2.41.37-1.67,1.42-3.02,3.58-2.53v1.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-4",
    "data-name": "am",
    className: "microsites-phase4-10",
    d: "M82.3,576.61c-5.49.25-3.33-7.16-3.77-11.98h1.98v7.41c0,1.91.43,3.09,2.41,3.02,4.44-.12,2.78-6.23,3.09-10.43h1.91l.06,11.73h-1.85c-.06-.62.06-1.54-.12-2.04-.68,1.36-1.73,2.22-3.7,2.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-7",
    "data-name": "au",
    className: "microsites-phase4-10",
    d: "M96.68,564.39c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-6",
    "data-name": "ay",
    className: "microsites-phase4-10",
    d: "M110.14,567.54c-.19-2.1-5.31-2.35-5.37,0,.93,3.27,7.1.74,7.35,5.56s-9.26,4.57-9.69.49l1.73-.31c.25,2.22,5.99,2.78,6.05,0-.62-3.46-6.98-.93-7.28-5.56-.25-3.52,5.06-3.89,7.53-2.59.74.43,1.3,1.17,1.48,2.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    id: "am-5",
    "data-name": "am",
    className: "microsites-phase4-10",
    d: "M124.27,576.61c-5.49.25-3.33-7.16-3.77-11.98h1.98v7.41c0,1.91.43,3.09,2.41,3.02,4.44-.12,2.78-6.23,3.09-10.43h1.91l.06,11.73h-1.85c-.06-.62.06-1.54-.12-2.04-.68,1.36-1.73,2.22-3.7,2.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-8",
    "data-name": "au",
    className: "microsites-phase4-10",
    d: "M138.66,564.39c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-13",
    "data-name": "ap",
    className: "microsites-phase4-10",
    d: "M147.42,573.47c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-9",
    "data-name": "at",
    className: "microsites-phase4-10",
    d: "M151.44,562.11v-1.85h1.98v1.85h-1.98ZM151.44,576.37v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-4",
    "data-name": "ar",
    className: "microsites-phase4-10",
    d: "M156.31,576.37v-16.11h1.98v16.11h-1.98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ap-14",
    "data-name": "ap",
    className: "microsites-phase4-10",
    d: "M169.52,573.47c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs-4",
    "data-name": "bs",
    className: "microsites-phase4-10",
    d: "M178.6,565.93c-4.44,0-2.72,6.3-3.02,10.43h-1.98v-16.11h1.98l-.06,6.36c.74-1.3,1.73-2.22,3.77-2.22,5.49,0,3.27,7.16,3.7,11.98h-1.98v-7.47c.12-1.98-.49-3.02-2.41-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-13",
    "data-name": "aq",
    className: "microsites-phase4-10",
    d: "M190.57,564.39c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM193.78,569.39c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aq-14",
    "data-name": "aq",
    className: "microsites-phase4-10",
    d: "M96.22,591.06c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM99.43,596.06c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-9",
    "data-name": "au",
    className: "microsites-phase4-10",
    d: "M109.61,591.06c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-5",
    "data-name": "aA",
    className: "microsites-phase4-10",
    d: "M119.98,591.06c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM120.54,592.54c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aA-6",
    "data-name": "aA",
    className: "microsites-phase4-10",
    d: "M138.5,591.06c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM139.06,592.54c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-10",
    "data-name": "an",
    className: "microsites-phase4-10",
    d: "M154.31,600.81c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM148.56,599.76c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-15",
    "data-name": "ap",
    className: "microsites-phase4-10",
    d: "M161.59,600.13c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-15",
    "data-name": "aq",
    className: "microsites-phase4-10",
    d: "M170.29,591.06c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM173.5,596.06c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  })))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-1",
    d: "M133.27,503.98h-1v-10.62h1v10.62ZM232.35,453.22l-.08,1-.24,1-.4.93-.52.86-.66.78-.78.66-.87.53-.94.4-1,.23-1,.08h-87.07l-.88.07-.84.2-.8.34-.73.45-.65.55-.56.66-.46.74-.33.8-.2.84-.06.88v6.8h-1v-6.84l.08-1,.24-1,.4-.93.52-.88.66-.78.78-.66.87-.53.93-.4,1-.23,1-.08h87.07l.88-.07.84-.2.8-.33.73-.45.66-.57.57-.66.45-.73.33-.8.2-.84.07-.88v-54.64h1v54.7Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-2",
    d: "M231.85,398.04l.5-.02v.53h-1v-.54l.5.03Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-1",
    d: "M231.85,398.02l.53-.02v.58h-1.05v-.58l.52.02ZM231.38,398.52h.95v-.47h-.95v.47Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-2",
    d: "M132.77,518.74l-4.63-14.26h9.28l-4.65,14.26Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "microsites-phase4-1",
    d: "M132.77,520.36l-5.32-16.38h10.64l-5.32,16.38ZM128.82,504.98l3.94,12.14,3.95-12.14h-7.89Z"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bz",
    className: "microsites-phase4-8",
    d: "M122.21,481.21v5.04h-2.57v-5.04l-4.35-7.21h2.67l2.96,5.19,2.96-5.19h2.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bA",
    className: "microsites-phase4-8",
    d: "M128.04,486.25v-12.25h9.63v1.98h-7.06v3.11h6.52v1.98h-6.52v3.21h7.41v1.98h-9.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB",
    className: "microsites-phase4-8",
    d: "M147.05,477.26c-.05-2.12-4.64-2.27-4.79-.15.89,3.26,7.46.49,7.6,5.63.15,4.69-8.15,4.59-10.07,1.78-.3-.4-.49-.94-.59-1.48l2.47-.4c.15,2.27,5.53,2.77,5.73.25-.84-3.41-7.41-.49-7.6-5.63-.2-4.3,7.56-4.35,9.28-1.73.25.4.4.89.49,1.38"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrositesPhase4);
export default __webpack_public_path__ + "static/media/Microsites-phase-4.4fabffd3ab1e47f998abc5dd5edf768b.svg";
export { ForwardRef as ReactComponent };